/**
 * Extension Bridge - Listens for messages from browser extension
 *
 * This module handles communication between the browser extension and the SPA.
 * The extension sends screen captures and triggers when Ctrl+Enter is pressed.
 */

export type ExtensionMessage =
  | { type: 'SCREEN_CAPTURE'; data: string; timestamp: number }
  | { type: 'EXTENSION_READY'; version: string }
  | { type: 'HOTKEY_TRIGGERED'; key: string };

// Listen for messages from extension
window.addEventListener('message', (event: MessageEvent<ExtensionMessage>) => {
  // Only accept messages from the same origin
  if (event.origin !== window.location.origin) {
    return;
  }

  const message = event.data;

  switch (message.type) {
    case 'EXTENSION_READY':
      console.log('🔌 Extension connected, version:', message.version);
      // @ts-expect-error - Extension injected global
      window.__ENTER_CONTROL_EXTENSION__ = true;
      window.dispatchEvent(new Event('extension-ready'));
      break;

    case 'SCREEN_CAPTURE':
      console.log('📸 Screen capture received:', message.data.substring(0, 50) + '...');
      handleScreenCapture(message.data, message.timestamp);
      break;

    case 'HOTKEY_TRIGGERED':
      console.log('⌨️ Hotkey triggered:', message.key);
      handleHotkeyTrigger(message.key);
      break;

    default:
      console.warn('Unknown message type:', message);
  }
});

/**
 * Handle screen capture from extension
 */
function handleScreenCapture(dataUrl: string, timestamp: number) {
  // Store screen capture in IndexedDB or send to backend
  const event = new CustomEvent('screen-capture', {
    detail: { dataUrl, timestamp },
  });
  window.dispatchEvent(event);
}

/**
 * Handle hotkey trigger from extension
 */
function handleHotkeyTrigger(key: string) {
  // Open chat interface or trigger action
  const event = new CustomEvent('hotkey-triggered', {
    detail: { key },
  });
  window.dispatchEvent(event);
}

// Ping extension to check if it's installed
setTimeout(() => {
  window.postMessage({ type: 'SPA_READY' }, '*');
}, 100);

console.log('🎯 Extension bridge initialized');
